import { PagingRequest } from '../common/paging';
import { NoticeStatus } from '../notices/notice.enums';
import { Configuration } from '../../configuration';

export class MatchingCaSearchRequest extends PagingRequest {
    supplierId: number;
    status: NoticeStatus;
    publishedDateFrom: string;
    publishedDateTo: string;
    noticeId: number;

    constructor(configuration: Configuration) {
        super(configuration);

        this.status = NoticeStatus.Live;
        this.sortProperty = 'B2BRef';
        this.descending = true;
    }

    equals(other: MatchingCaSearchRequest): boolean {
        return this.status === other.status &&
            this.publishedDateTo === other.publishedDateTo &&
            this.publishedDateFrom === other.publishedDateFrom &&
            super.equals(other);
    }
}

export class MatchingCaSummaryDto {
    id: string;
    title: string;
    b2BRef: number;
    type: string;
    location: string;
    description: string;
    bookmarked: boolean;
    bookmarkedById: number;
    bookmarkedBy: string;
    jsBookmarkedDate: string;
    selected: boolean;
}

export class RemoveMatchDto {
    matchingTenderId: string;
}

export class RemoveMatchesDto {
    matches: Array<RemoveMatchDto>;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/models/contract.awards/matching.contract.award.models.ts